import { css } from 'styled-components';
import { BreakpointQueryName, getTypography, TypographyName } from '../../theme';
export const base = () => css(["display:flex;"]);
export const nav = _ref => {
  let {
    theme
  } = _ref;
  return css(["display:none;ul{display:flex;}", "{display:block;}"], theme.breakpoints.up(BreakpointQueryName.MD));
};
export const status = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", ";margin:0 ", ";font-weight:normal;width:3.125rem;height:3.125rem;display:flex;align-items:center;justify-content:center;", "{display:none;}"], getTypography(theme, TypographyName.H4), theme.spaceUnits.mobile.SMALL, theme.breakpoints.up(BreakpointQueryName.MD));
};
export const page = _ref3 => {
  let {
    theme,
    $active
  } = _ref3;
  return css(["margin-left:", ";width:3.125rem;flex-basis:3.125rem;border-radius:", ";", " &:last-child{margin-right:", ";}"], theme.spaceUnits.desktop.SMALL, theme.button.borderRadius, $active && `
    background-color: ${theme.palettes.neutrals.light};
  `, theme.spaceUnits.desktop.SMALL);
};
export const points = _ref4 => {
  let {
    theme
  } = _ref4;
  return css(["margin-left:", ";color:", ";height:3.125rem;line-height:3.125rem;&:last-child{margin-right:", ";}"], theme.spaceUnits.desktop.SMALL, theme.palettes.neutrals.medium, theme.spaceUnits.desktop.SMALL);
};
//# sourceMappingURL=Pagination.style.js.map